import { SR_API_ACTION_RATE_TOUR } from 'api/actionTypes';

import getTourList from 'client/actions/Tour/getList';
import askWantsToApply from 'client/actions/Listing/askWantsToApply';

export default async function rateShowing({ state, apiClient }, {
  tourId,
  rating,
  tags,
  feedback,
  listing,
  skipReview,
}) {
  return apiClient.postWithState({
    state: state,
    action: SR_API_ACTION_RATE_TOUR,
    payload: {
      tourId,
      rating,
      tags,
      feedback,
      listingId: listing.id,
      skipReview,
    },
    onSuccess: () => {
      if (rating > 3) {
        askWantsToApply({ state, apiClient }, listing);
      }

      getTourList({ state, apiClient }, { reloadTours: true });
    },
  });
}
